<div class="jolojo-spacer" class:editing={$store.editor.mode === modes.EDIT || fields?.preview}
  style:height={windowWidth > 650 ? `${fields.height - 2}px` : `${fields.mobileHeight - 2}px`}
>
</div>

<svelte:window bind:innerWidth={windowWidth} />

<script>
  import { getContext } from 'svelte'

  const platform = getContext('platform')

  const { store } = platform
  const { modes } = platform.api.cms.editor

  export let fields = {}

  let windowWidth = 0
</script>

<style>
  .jolojo-spacer {
    margin: 1px 0;
    min-height: 20px;
    width: 100%;
    min-width: 20px;
  }

  .editing {
    background: repeating-linear-gradient(
      45deg,
      white,
      white 10px,
      rgb(190, 190, 190) 10px,
      rgb(190, 190, 190) 20px
    );
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>